/**
 * 积分相关接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const integral = {

    //前台获取所有积分兑换商品信息
    getIntegralShopList(params) {
        return axios.post('/goods/integralShop/getIntegralShopList', qs.stringify(params));
    },
    //获取积分兑换详情信息
    getIntegralGoodsDetail(params) {
        return axios.post('/goods/integralShop/getIntegralGoodsDetail', qs.stringify(params));
    },
    //兑换积分
    convertGoods(params) {
        return axios.post('/goods/integralShop/convertGoods', qs.stringify(params));
    },
    //获取用户积分兑换记录
    convertRecord(params) {
        return axios.post('/goods/integralShop/convertRecord', qs.stringify(params));
    }

}

export default integral;


// WEBPACK FOOTER //
// ./src/request/api/integral/integral.js